/* eslint-disable import/no-unresolved */
import paperSVG from 'assets/resources/icon/paper_icon.svg';
import enterpriseSVG from 'assets/resources/icon/enterprise.svg';
import frontendSVG from 'assets/resources/icon/frontend.svg';
import FrontendTechSVG from 'assets/resources/frontend.inline.svg';
import BackendTechSVG from 'assets/resources/backend.inline.svg';
import MobileTechSVG from 'assets/resources/mobile.inline.svg';
import chainSVG from 'assets/resources/icon/chain_icon.svg';
import logoJS from 'assets/resources/icon/logo_js.svg';
import consultingSVG from 'assets/resources/icon/3_icon.svg';
import blockchainIconSVG from 'assets/resources/pages/software-services/blockchain_icon.svg';
import icon2SVG from 'assets/resources/pages/about-us/2_icon.svg';
import codeauditSVG from 'assets/resources/icon/codeaudit_icon.svg';
import bankSVG from 'assets/resources/icon/bank.svg';
import cloadSVG from 'assets/resources/icon/cload.svg';
import globusSVG from 'assets/resources/icon/globus.svg';
import graphSVG from 'assets/resources/icon/graph.svg';
import phoneSVG from 'assets/resources/icon/phone.svg';
import walletSVG from 'assets/resources/icon/wallet_icon.svg';
import pythonPillar from 'assets/resources/icon/pythonPillar.svg';
import bitcoinPillar from 'assets/resources/icon/bitcoinPillar.svg';
import buildingproductsSVG from 'assets/resources/icon/buildingproducts_icon.svg';
import cheapSVG from 'assets/resources/icon/cheap.svg';
import performanceSVG from 'assets/resources/icon/performance.svg';
import ondemandSVG from 'assets/resources/icon/ondemand team.svg';
import rocketSVG from 'assets/resources/icon/rocket.svg';
import scrumSVG from 'assets/resources/icon/scrum_icon.svg';
import backendSVG from 'assets/resources/icon/backend.svg';
import checkmarkSVG from 'assets/resources/icon/checkmark.svg';

export default {
  paperSVG,
  enterpriseSVG,
  chainSVG,
  frontendSVG,
  consultingSVG,
  blockchainIconSVG,
  FrontendTechSVG,
  BackendTechSVG,
  MobileTechSVG,
  icon2SVG,
  codeauditSVG,
  logoJS,
  bankSVG,
  cloadSVG,
  globusSVG,
  graphSVG,
  phoneSVG,
  walletSVG,
  pythonPillar,
  bitcoinPillar,
  buildingproductsSVG,
  cheapSVG,
  performanceSVG,
  ondemandSVG,
  rocketSVG,
  scrumSVG,
  backendSVG,
  checkmarkSVG
};
